// extracted by mini-css-extract-plugin
module.exports = {"main_container":"RegistrationStatus_main_container_uzgF4","show-label":"RegistrationStatus_show-label_3rP4T"};